<template>
    <div>
        <div class="admin-controls">
            <TxSettingsUi>
                <div :title="'0. Admin Settings'">
                    <LoveMapButton
                            label="Copy User Template Object"
                            @click="onCopy"
                    >
                        Copy User Object
                    </LoveMapButton>
                    <br/>

                    <LoveMapToggle
                            name="txUseData"
                            :input="true"
                            label="Template Object"
                            :options="txUseDataOptions"
                            :value="txUseData"
                            @input="onTxUseData"
                    />
                    <br/>

                    <LoveMapToggle
                            label="Select Template"
                            :options="txTemplates"
                            :value="$root.template"
                            @input="setTemplate"
                    />
                    <br/>
                </div>
            </TxSettingsUi>
        </div>
        <div class="grid-container">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "admin",
        data() {
            return {
                txUseData: 'user',
                txUseDataOptions: [
                    {
                        label: 'User Defined',
                        value: 'user',
                    },
                    {
                        label: 'Admin Defined',
                        value: 'admin',
                    },
                ],
                txTemplates: [
                    {
                        label: 'Lovemap',
                        value: 'lovemap',
                    },
                    {
                        label: 'Stadkarta',
                        value: 'city-map',
                    },
                    {
                        label: 'Poster text',
                        value: 'poster-text',
                    },
                ],
            }
        },
        created() {
            this.txUseData = window.txUseData
        },
        computed: {
            lovemap() {
                return window.lovemap;
            }
        },
        methods: {
            onTxUseData(val) {
                this.txUseData = val
                this.$root.reloadDefaultState(val === 'user' ? window.mapData : window.adminMapData)
            },
            onCopy() {
                this.txUseData = 'admin'
                this.$root.reloadDefaultState(window.mapData)
            },
            setTemplate(val) {
                this.$root.setTemplate(val, true)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .grid-container {
        display: grid;
        grid-template-columns: calc(70% - 15px) 30%;
        grid-template-rows: auto auto;
        grid-template-areas: ". ." ". .";
        grid-column-gap: 15px;
        grid-row-gap: 15px;
    }

    .admin-controls {
        margin-top: 20px;
        /*padding: 10px 0;*/
        /*margin: 10px;*/
    }
</style>